import { useQuery } from "@tanstack/react-query";
import { fetchCompanyNotes } from "../api/fetchCompanyNotes";

export const useCompanyNotes = (companyId, enabled = true) => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["companyNotes", companyId],
    queryFn: () => fetchCompanyNotes(companyId),
    enabled: !!companyId && enabled,
  });

  return {
    data: data?.result?.notes || [],
    error,
    isLoading,
    refetch,
  };
};

